import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Collapse, Spin, Typography, Space, Button } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { usePermission } from "../../../../hooks/accessControl";
import { useIntl } from "react-intl";
import Dropzone from "./Dropzone";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import { fetchList, generateAssetDownloadURL } from "../../../../api/server";
import moment from "moment";
const { Panel } = Collapse;
const Files = (props) => {
  const { resource, branchId } = props;
  let { id } = useParams();
  const intl = useIntl();
  const userScope = useSelector((state) => state.user.scopePrefix);
  const hasEditorPermission = usePermission(branchId, "assets", "editor");
  const [refreshTimestamp, setRefreshTimestamp] = useState(moment().format());
  const scope = resource && id ? `${resource}/${id}/` : "";

  const scopePrefix = branchId
    ? `branches/${branchId}/${scope}`
    : `${userScope}${scope}`;

  const assetsPage = {
    current: 1,
    order: { field: "created_at", order: "descend" },
    pageSize: 10,
  };

  const { isLoading, data } = useQuery(
    [assetsPage, scope, branchId, resource, id, refreshTimestamp],
    async () => {
      const result = await fetchList("assets", {
        ...assetsPage,
        scopePrefix,
      });
      return result.data.items;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled: id !== null,
    }
  );

  const onDownloadFile = async (f) => {
    const scope = branchId
      ? `/branches/${branchId}/${f.owner_type}/${f.owner_id}`
      : "";

    const {
      data: { url },
    } = await generateAssetDownloadURL(scope, f.id);
    openURL(url, f.name);
  };

  const openURL = (url, name) => {
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = "test";
    downloadLink.title = "Download";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const changeRefreshTimestamp = () => {
    setRefreshTimestamp(moment().format());
  };
  return (
    <div className="component">
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        className="custom-collapse-section"
        style={{ padding: 0, margin: 0 }}
      >
        <Panel
          header={intl.formatMessage({
            id: "app.crm.files",
          })}
          key={"1"}
        >
          <div style={{ display: "flex" }}>
            <div style={{ width: "100%" }}>
              {isLoading ? (
                <Spin />
              ) : data ? (
                <Space direction="vertical" size={1} style={{ width: "100%" }}>
                  {data.map((r) => (
                    <Button
                      style={{ padding: "4px 0" }}
                      type="link"
                      onClick={() => onDownloadFile(r)}
                    >
                      {r.name}
                    </Button>
                  ))}
                </Space>
              ) : null}
            </div>

            {hasEditorPermission && (
              <Dropzone
                resource={"patients"}
                branchId={branchId}
                id={id}
                changeRefreshTimestamp={changeRefreshTimestamp}
              />
            )}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default Files;
